import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { RegionModel } from '../../shared/models/region';
import { StateModel } from '../../shared/models/state';
import { CampaignProvider } from '../../shared/providers/campaign.provider';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { StateProvider } from '../../shared/providers/state.provider';

@Component({
  selector: 'app-general-reports',
  templateUrl: './general-reports.component.html',
  styleUrls: ['./general-reports.component.scss']
})
export class GeneralReportsComponent implements OnInit {
  regions: RegionModel[];
  states: StateModel[];
  StatesfilterByRegion: StateModel[];
  resetData: any[];
  resetDate: any;
  tseUsers: any[];
  m2Users: any[];
  m3Users: any[];
  tmmUsers: any[];
  //
  tsefilterByStateOrRegion: any[] = [];
  m2filterByStateOrRegion: any[] = [];
  m3filterByStateOrRegion: any[] = [];
  tmmfilterByStateOrRegion: any[] = [];
  /**********************/
  filteredDetails: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",

  };
  filteredDetailsForApi: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
  };
  resetFilteredDetailsForApi: any = {
    search_string: "",
    regions: [],
    states: [],
    tse: [],
    m2: [],
    m3: [],
    tmm: [],
    start_date: "",
    end_date: "",
  };

  resetDropdown: boolean;
  disable: boolean = false;
  outletCode: any;

  constructor(private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    public adminDataProvider: AdminDataProvider,
    public campaignProviders: CampaignProvider,
    private formateDate: DateFormateService,
    public regionProviders: RegionProvider,
    public channelProviders: ChannelProvider,
    private userRoles: RolesProvider,
    public stateProvider: StateProvider,
    public alertService: AlertService,
    public exportExcelService: ExportExcelService,
    private ngxService: NgxUiLoaderService,) { }

  ngOnInit() {
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.states = this.stateProvider.state;
    this.tseUsers = this.stateProvider.tseUsers;
    this.m2Users = this.stateProvider.m2Users;
    this.m3Users = this.stateProvider.m3Users;
    this.tmmUsers = this.stateProvider.tmmUsers;
  }



  selectedDates(dates) {
    if (dates.from) {
      this.filteredDetailsForApi.start_date = this.formateDate.formateDate(
        dates.from
      );
    }
    if (dates.to) {
      this.filteredDetailsForApi.end_date = this.formateDate.formateDate(
        dates.to
      );
    }
    if (!dates.from) {
      this.filteredDetailsForApi.start_date = "";
    }
    if (!dates.to) {
      this.filteredDetailsForApi.end_date = "";
    }

    if (this.filteredDetailsForApi.start_date != "" && this.filteredDetailsForApi.end_date != "") {
      this.disable = true;
    }
  }

  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // resions
        this.filteredDetails.regions = await data;
        this.StatesfilterByRegion = [];
        this.m2filterByStateOrRegion = [];
        this.m3filterByStateOrRegion = [];
        this.tsefilterByStateOrRegion = [];
        this.tmmfilterByStateOrRegion = [];
        let item = data;
        if (item.length > 0) {
          item.forEach((element) => {
            this.StatesfilterByRegion.push(
              ...this.states.filter(
                (s) => s.region_id == element.id && s.state_year == 2021
              )
            );
            this.m2filterByStateOrRegion.push(
              ...this.m2Users.filter(
                (s) => s.region_id == element.id
              )
            );

            this.m3filterByStateOrRegion.push(
              ...this.m3Users.filter(
                (s) => s.region_id == element.id
              )
            );
            this.tsefilterByStateOrRegion.push(
              ...this.tseUsers.filter(
                (s) => s.region_id == element.id
              )
            );
            this.tmmfilterByStateOrRegion.push(
              ...this.tmmUsers.filter(
                (s) => s.region_id == element.id
              )
            );
          });
        }
        break;
      case 2: // State
        this.m2filterByStateOrRegion = [];
        this.m3filterByStateOrRegion = [];
        this.tsefilterByStateOrRegion = [];
        this.tmmfilterByStateOrRegion = [];
        this.filteredDetails.states = await data;
        let statedata = data;
        if (statedata.length > 0) {
          statedata.forEach((element) => {
            this.m2filterByStateOrRegion.push(
              ...this.m2Users.filter(
                (s) => s.state_code == element.id
              )
            );
            this.m3filterByStateOrRegion.push(
              ...this.m3Users.filter(
                (s) => s.state_code == element.id
              )
            );
            this.tsefilterByStateOrRegion.push(
              ...this.tseUsers.filter(
                (s) => s.state_code == element.id
              )
            );
            this.tmmfilterByStateOrRegion.push(
              ...this.tmmUsers.filter(
                (s) => s.state_code == element.id
              )
            );
          });
        }
        break;
      case 3: // city
        this.filteredDetails.tse = await data;
        break;
      case 4: // geography
        this.filteredDetails.m2 = await data;
        break;
      case 5: // geography
        this.filteredDetails.m3 = await data;
        break;
      case 6: // geography
        this.filteredDetails.tmm = await data;
        break;
      default:
        break;
    }
  }

  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.tmm = this.filteredDetails.tmm
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.tse = this.filteredDetails.tse
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.m1 = this.filteredDetails.m1
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.m2 = this.filteredDetails.m2
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.m3 = this.filteredDetails.m3
        .map((i) => i.id)
        .join(",")
        .toString();
      // this.outletCode = this.filteredDetails.search_string;
    } catch (error) { }
    console.log(this.filteredDetailsForApi);
    this.getAccountLoginReport(this.filteredDetailsForApi);
  }

  filterResetListOfRecords() {
    this.resetDropdown = true;
    this.resetData = [];
    this.resetDate = undefined;
    this.filteredDetailsForApi = this.resetFilteredDetailsForApi;
    this.disable = true;
  }

  getAccountLoginReport(data) {

    this.outletCode = (typeof this.outletCode != "undefined") ? this.outletCode : null;
    
    this.ngxService.start();
    this.apiService
      .getHeaders(
        this.apiConfig.getAccountLoginReport +
        "?report_id=" +
        13 +
        "&fromdate=" +
        data.start_date +
        "&todate=" +
        data.end_date +
        "&region_id=" +
        data.regions +
        "&state_code=" +
        data.states +
        "&tse=" +
        data.tse +
        "&m2=" +
        data.m2 +
        "&m3=" +
        data.m3 +
        "&m2=" +
        data.tmm + 
        "&rocode=" + this.outletCode
      )
      .subscribe(
        (res: any) => {
          if (res.body.data.report_data.length > 0) {
            this.exportExcelService.exportUserLoginReport(res.body.data.report_data);
            this.clearSuccess();
            this.ngxService.stop();
          }
          else {
            this.alertService.warning("No Data Found")
            this.clearSuccess();
            this.ngxService.stop();
          }
        },
        (err) => {
          console.log(err);
          this.ngxService.stop();
        }
      );
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }


}
